import { render, staticRenderFns } from "./CompareOptions.vue?vue&type=template&id=b6bc0b60&scoped=true&"
import script from "./CompareOptions.vue?vue&type=script&lang=ts&"
export * from "./CompareOptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6bc0b60",
  null
  
)

export default component.exports